import { ViewWidgetHelper } from '../../view/ViewWidgetHelper.js';
import { TableServerCmd, TableServerEvents, writeTpk } from './ITableWidget.js';

/**
 * Контроллер предметных операций таблицы.
 * Отвечает за выполнение ItemsCommand и делегирует TableWidget только визуальную часть.
 */
class TableItemsController {
    /**
     * @param table   Интерфейс виджета таблицы
     */
    constructor(table) {
        this._table = table;
    }
    // ── Выбор ────────────────────────────────
    /** Сделать текущими строки по id */
    select(ids) {
        this._table.selection.set(ids);
        this._table.refreshState();
    }
    /** Отметить все строки */
    selectAll() {
        this._table.selAdapter?.selectAll();
        this._table.refreshState();
    }
    /** Снять выделение строк по id */
    unselect(id) {
        this._table.selection.unselectMany(id);
        this._table.refreshState();
    }
    /** Снять выделение всех строк */
    unselectAll() {
        this._table.selection.clear();
        this._table.refreshState();
    }
    // ── CRUD ─────────────────────────────────
    /** Удалить все выбранные строки */
    deleteSelected() {
        const idx = this._table.checkedRowsIndexes?.() ?? '';
        if (!idx)
            return; // ← нет выбора — ничего не шлём
        this.execRowsCmd(TableServerCmd.delete_rows, false, idx);
    }
    /**
     * Перезагрузка одной строки по её id.
     * @param rowID id строки (data-id)
     * @param inserted true — если это новая вставленная строка (append), иначе заменить существующую
     */
    reload(rowID, inserted = false) {
        if (!rowID)
            return;
        this._table.showLoading();
        ViewWidgetHelper.ExecCmd(this._table.element, {
            cmd: TableServerCmd.reload_row,
            options: { rowid: rowID },
            onSuccess: (data) => {
                /** Вставка/замена DOM для строки после reloadRow */
                this._table.reloadRowComplete(data?.html, inserted, data?.footer);
                /** Уведомление об изменении данных таблицы */
                this._table.onDataChanged(TableServerEvents.reloadrow, rowID);
                this._table.hideLoading();
            },
            onError: () => {
                console.error("err reloadRow");
                this._table.hideLoading();
            }
        });
    }
    /** Полностью перезагрузить таблицу */
    reloadAll(ids, callback) {
        this._table.showLoading();
        ViewWidgetHelper.ExecCmd(this._table.element, {
            cmd: TableServerCmd.reload_tbody,
            onSuccess: (data) => {
                // DOM/визуальная часть — у виджета
                this._table.reloadComplete(data?.html, data?.footer);
                // уведомление, как и раньше
                this._table.onDataChanged(TableServerEvents.reload);
                // актуализация пагинации (ширины панели)
                this._table.setTablePagination();
                if (ids) {
                    this._table.selection.set(ids);
                    this._table.selAdapter.markRows(ids);
                    this._table.refreshState();
                }
                // вызываем callback, если передан
                if (callback)
                    callback();
            },
            onError: () => {
                // согласованно скрываем лоадер
                this._table.hideLoading();
            }
        });
    }
    // ── Порядок элементов ───────────────────
    /** Переместить элемент вверх */
    moveUp() {
        this.execRowsCmd(TableServerCmd.rowsmoveup, true);
    }
    /** Переместить элемент вниз */
    moveDown() {
        this.execRowsCmd(TableServerCmd.rowsmovedown, true);
    }
    execRowsCmd(cmd, restore = false, indexes) {
        this._table.showLoading();
        if (!indexes)
            indexes = this._table.checkedRowsIndexes();
        const options = { rowindexes: indexes };
        ViewWidgetHelper.ExecCmd(this._table.element, {
            cmd,
            options,
            onSuccess: () => {
                this.reloadAll(indexes.split(","), () => {
                    if (restore) {
                        const ids = indexes.split(",");
                        this._table.selection.set(ids);
                        this._table.selAdapter.markRows(ids);
                        this._table.refreshState();
                    }
                });
            },
            onError: () => { console.error('request error'); this._table.hideLoading(); }
        });
    }
    // ── Работа с папками ───────────────────
    /** Установить текущую (родительскую) папку / группу */
    setFolder(folderId) {
        writeTpk(this._table.element, this._table.tableKey, "groupID", folderId);
        writeTpk(this._table.element, this._table.tableKey, "curPage", "1");
        if (this._table.panel) {
            this._table.panel.setPage(1);
        }
        else
            this.reloadAll();
    }
}

export { TableItemsController };
